import type { PropsWithChildren } from 'react'
import React from 'react'

import { productTitle } from 'constants/constants'

import { Grid, Typography } from '@mui/material'

function BeforeLogin({ children }: PropsWithChildren) {
  return (
    <Grid container alignItems="center" justifyContent="center" direction="column" sx={{ minHeight: '100vh' }}>
      <Typography variant="largeBold" textAlign="center">
        {productTitle}
      </Typography>
      {children}
    </Grid>
  )
}

export default BeforeLogin
